import { getUserCountryCode, getUserSafeID } from 'helper/user';
import _get from 'lodash/get';

import {
  GA_EVENT,
  GA_PAGE_MAP,
  GA_CATEGORY,
  GA_ACTION,
  GA_STATUS,
  GA_LABELS,
} from '../constants/ga-constants';
import { COUNTRY_MAP } from '../constants/booking-constants';
import { STORAGE_CITY } from '../constants/app-constants';

// eslint-disable-next-line import/prefer-default-export
export const pushGAPageViewEvent = (type, userInfo, geTransactionType) => {
  const countryCode = getUserCountryCode(userInfo);

  window.pushGAEvent({
    event: GA_EVENT.GE_VIRTUAL_PV_EVENT,
    gePageView: GA_PAGE_MAP[type],
    paxSafeID: userInfo.user.safeID,
    geTransactionType,
    geSenderCountry: COUNTRY_MAP[countryCode],
    geSenderCity: window.localStorage.getItem(STORAGE_CITY),
  });
};

export const pushGAEvent = (userInfo, data) => {
  const countryCode = getUserCountryCode(userInfo);
  const getAll = _get(window, ['ga', 'getAll']);

  if (typeof getAll !== 'function') {
    return;
  }

  const trackers = getAll();
  if (!trackers || trackers.length === 0) {
    return;
  }
  const tracker = trackers[0];
  const client_id = tracker.get('clientId');
  const userSafeID = getUserSafeID(userInfo);

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    user_id: userSafeID,
    client_id,
    event: 'hm_push_event',
    country: countryCode,
    ...data,
  });
};

export const pushGALoginSuccessEvent = userInfo => {
  pushGAEvent(userInfo, {
    event_category: GA_CATEGORY.GRAB_CONVERSION,
    event_action: GA_ACTION.LOGIN,
    event_label: `Status-${GA_STATUS.SUCCESS}`,
    login_status: GA_STATUS.SUCCESS,
  });
};

export const pushGAAddDeliveryDetail = (
  userInfo,
  mode,
  totalPrice,
  deliveryType,
) => {
  pushGAEvent(userInfo, {
    event_category: GA_CATEGORY.GRAB_ENGAGEMENT,
    event_action: GA_ACTION.CLICK,
    event_label: `${mode}-${GA_LABELS.ADD_DELIVERIES_DETAIL}`,
    total_price: totalPrice,
    booking_type: mode,
    delivery_type: deliveryType,
    section_name: GA_LABELS.ADD_DELIVERY,
    click_text: GA_LABELS.ADD_DELIVERIES_DETAIL,
  });
};

export const pushGABookDeliveriesEvent = (
  userInfo,
  mode,
  totalPrice,
  deliveryType,
  numDeliveries,
) => {
  pushGAEvent(userInfo, {
    event_category: GA_CATEGORY.GRAB_ENGAGEMENT,
    event_action: GA_ACTION.CLICK,
    event_label: `${mode}-Book ${numDeliveries} Deliveries`,
    total_price: totalPrice,
    booking_type: mode,
    delivery_type: deliveryType,
    section_name: mode,
    click_text: `Book ${numDeliveries} ${
      numDeliveries === 1 ? 'Delivery' : 'Deliveries'
    }`,
  });
};

export const pushGADriverAssignedEvent = (
  userInfo,
  totalPrice,
  deliveryType,
  currencyCode,
) => {
  pushGAEvent(userInfo, {
    event_category: GA_CATEGORY.GRAB_CONVERSION,
    event_action: GA_ACTION.CONFIRMED,
    event_label: `${GA_LABELS.ON_GOING_BOOKINGS}-${GA_LABELS.RIDER_ASSIGNED}`,
    total_price: totalPrice,
    delivery_type: deliveryType,
    currency_code: currencyCode,
  });
};
